import React from "react";
import "./Aura.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import LogoAura from "../../assets/aura.svg";
import Mountain from "../../assets/mountain1.svg";
import Stars from "../../assets/stars.svg";

// Logos de parceiros
import LogoB3 from "../../assets/logos/b3.svg";
import LogoColgate from "../../assets/logos/colgate.svg";
import LogoCorteva from "../../assets/logos/corteva.svg";
import LogoEmbraer from "../../assets/logos/embraer.svg";
import LogoIsa from "../../assets/logos/isa.svg";
import LogoJaguar from "../../assets/logos/jaguar.svg";
import LogoLoreal from "../../assets/logos/loreal.svg";
import LogoNestle from "../../assets/logos/nestle.svg";
import LogoNexa from "../../assets/logos/nexa.svg";
import LogoPetrobras from "../../assets/logos/petrobras.svg";
import LogoPorto from "../../assets/logos/porto-acu.svg";
import LogoPrio from "../../assets/logos/prio.svg";
import LogoPrudential from "../../assets/logos/prudential.svg";
import LogoPrumo from "../../assets/logos/prumo.svg";
import LogoSaintGobain from "../../assets/logos/saint-gobain.svg";
import LogoSaoMartinho from "../../assets/logos/sao-martinho.svg";
import LogoStellantis from "../../assets/logos/stellantis.svg";
// import LogoVolksagen from "../../assets/logos/volkswagen.svg";
import LogoWilson from "../../assets/logos/wilsonsons.svg";

const PartnersCarousel = () => {
  const logos = [
    { src: LogoB3, alt: "B3" },
    { src: LogoColgate, alt: "Colgate" },
    { src: LogoCorteva, alt: "Corteva" },
    { src: LogoEmbraer, alt: "Embraer" },
    { src: LogoIsa, alt: "Isa" },
    { src: LogoJaguar, alt: "Jaguar" },
    { src: LogoLoreal, alt: "Loreal" },
    { src: LogoNestle, alt: "Nestle" },
    { src: LogoNexa, alt: "Nexa" },
    { src: LogoPetrobras, alt: "Petrobras" },
    { src: LogoPorto, alt: "Porto" },
    { src: LogoPrio, alt: "PRIO" },
    { src: LogoPrudential, alt: "Prudential" },
    { src: LogoPrumo, alt: "Prumo" },
    { src: LogoSaintGobain, alt: "SaintGobain" },
    { src: LogoSaoMartinho, alt: "SaoMartinho" },
    { src: LogoStellantis, alt: "Stellantis" },
    // { src: LogoVolksagen, alt: "Volkswagen" },
    { src: LogoWilson, alt: "WilsonSons" }
  ];

  return (
    <div className="partners-carousel-container-2">
      <motion.div 
        className="partners-carousel-2"
        animate={{ x: [0, -50 + "%"] }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 40,
            ease: "linear",
          },
        }}
        style={{ willChange: "transform" }}
      >
        {[...logos, ...logos, ...logos, ...logos].map((logo, index) => (
          <div key={index} className="partner-logo-2">
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </motion.div>
    </div>
  );
};


const Aura = () => {
  const navigate = useNavigate();

  return (
    <motion.div
          className="aura-container"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -24 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
      {/* Elementos de fundo */}
      <img src={Stars} alt="Estrelas no céu" className="stars-background" />
      <img src={Mountain} alt="Montanhas" className="mountain-background" />

      {/* Texto e carrossel de parceiros */}
      <p className="partners-title">Uma parceria de sucesso</p>
      <PartnersCarousel />

      {/* Conteúdo principal da tela */}
      <main className="aura-content">
        <p className="aura-intro-text">Olá, eu sou a</p>
        <img src={LogoAura} alt="Logo Aura" className="aura-logo" />
        <p className="aura-subtitle">
          Resolvo seu processo em 6 semanas
        </p>

        {/* Reutilizando o estilo do botão primário global */}
        <motion.button
          className="primary-button"
          onClick={() => navigate("/onboarding")}
          initial={{ opacity: 0.8, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            duration: 0.8, 
            ease: "easeInOut",
            repeat: Infinity,      // keeps looping
            repeatType: "reverse", // goes back and forth (ping-pong) 
          }}
        >
          Começar agora!
        </motion.button>
      </main>
    </motion.div>
  );
};

export default Aura;
